import { apiClient } from "lib/apiClient";
import { IResearchWorkItem } from "features/Research/types";

export const restoreResearchWorkItem = async (
  workItemId: string,
  version: number
): Promise<IResearchWorkItem> => {
  const response = await apiClient.delete(
    `/research/work-items/${workItemId}/archival`,
    { params: { version } }
  );
  return response.data;
};
